<template>
    <div class="rfq" >
        <el-card >
            <el-breadcrumb separator="/">
                <!-- <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item> -->
                <el-breadcrumb-item>客户端商品采购</el-breadcrumb-item>
                <el-breadcrumb-item>与天创结算清单</el-breadcrumb-item>
            </el-breadcrumb>
        </el-card>
        <main class="content">
            <el-card>
                <el-form :inline="true" :model="searchForm" size="mini">
                    <el-form-item label="公司名称" prop="companyIds" label-width="70px"  >
                        <el-select multiple filterable  collapse-tags clearable size="mini" mul v-model="searchForm.companyIds" :disabled="loading" placeholder="公司名称"  style="width: 300px">
                            <el-option
                                v-for="item in companys"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="下单日期">
                        <el-date-picker size="mini" v-model="searchForm.timeDate" type="daterange" range-separator="至" start-placeholder="开始日期"
                            :disabled="loading" end-placeholder="结束日期" value-format="yyyy-MM-dd" :picker-options="pickerOptions"  clearable>
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="状态">
                        <el-select v-model="searchForm.status" placeholder="状态" size="mini" :disabled="loading">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="未开票" value="10"></el-option>
                            <el-option label="已开票" value="1"></el-option>
                            <el-option label="已结算" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSearch" size="mini" :loading="loading">查询</el-button>
                    </el-form-item>
                </el-form>
                <el-table
                    stripe
                    :data="tableData"
                    size="mini"
                    v-loading="loading"
                    style="width: 100%">
                    <!-- <el-table-column type="selection" width="55" :selectable="judgeSelect" fixed/> -->
                    <el-table-column
                        fixed
                        prop="sku"
                        label="SKU" width="180">
                    </el-table-column>
                    <el-table-column
                            prop="productName"
                            label="商品名称" width="300">
                    </el-table-column>
                    <el-table-column
                            prop="model"
                            label="商品型号" width="200">
                    </el-table-column>
                    <el-table-column
                            prop="num"
                            label="商品数量" width="100">
                    </el-table-column>
                    <el-table-column
                            prop="unit"
                            label="商品单位" width="100">
                    </el-table-column>
                    <el-table-column
                            prop="untaxedPrice"
                            label="未税单价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="price"
                            label="已税总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalUntaxedPrice"
                            label="未税总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="totalPrice"
                            label="含价总价(元)"
                            width="150"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="companyName"
                            label="公司" width="180">
                    </el-table-column>
                    <el-table-column
                        prop="email"
                        label="用户邮箱" width="180">
                    </el-table-column>
                    <el-table-column
                        prop="consignee"
                        label="收货人" width="100">
                    </el-table-column>
                    <el-table-column
                        prop="mobile"
                        label="收货人手机" width="120">
                    </el-table-column>
                    <el-table-column
                        prop="address"
                        label="收货地址" width="200">
                    </el-table-column>
                    <el-table-column
                        prop="createTime"
                        label="提报时间" width="200" align="center">
                    </el-table-column>
                    <el-table-column
                        prop="orderTime"
                        label="下单时间" width="200" align="center">
                    </el-table-column>
                     <el-table-column
                            fixed="right"
                            prop="status"
                            label="状态"
                            width="100" align="center">
                         <template slot-scope="scope">
                            <el-tag v-if="scope.row.status == 0">待审批</el-tag>
                            <el-tag v-if="scope.row.status == 1">待审批</el-tag>
                            <el-tag v-if="scope.row.status == 2">已下单</el-tag>
                            <el-tag v-if="scope.row.status == 3">已发货</el-tag>
                            <el-tag v-if="scope.row.status == 4">已收货</el-tag>
                            <el-tag v-if="scope.row.status == 5">已取消</el-tag>
                            <el-tag v-if="scope.row.status == 6">缺货</el-tag>
                            <el-tag v-if="scope.row.status == 7">审核驳回</el-tag>
                            <el-tag v-if="scope.row.status == 8">拒收</el-tag>
                         </template>
                     </el-table-column>
                    <el-table-column
                            fixed="right"
                            prop="isInvoice"
                            label="发票"
                            width="100" align="center">
                            <template slot="header">
                                <el-button type="primary" size="mini" @click="exportData()">导出</el-button>
                            </template>
                            <template slot-scope="scope">
                                <el-tag v-if="!scope.row.isInvoice">未开票</el-tag>
                                <el-tag v-if="scope.row.isInvoice&&scope.row.invoiceStatus == 0">已申请</el-tag>
                                <el-tag v-if="scope.row.isInvoice&&scope.row.invoiceStatus == 1">已开票</el-tag>
                                <el-tag v-if="scope.row.isInvoice&&scope.row.invoiceStatus == 2">已结算</el-tag>
                            </template>

                    </el-table-column>
                    <!-- <el-table-column label="操作" width="100" align="right" fixed="right">
                        <template slot="header">
                            <el-button type="primary" size="mini" @click="exportData()">导出</el-button>
                        </template>
                        <template slot-scope="scope">
                            <el-button size="mini"
                                @click="handleToReviewDetail(scope.row)">详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
                <div style="text-align: center;padding-top: 20px">
                    <el-pagination
                        background
                        :current-page="currentPage"
                        v-if="total>0"
                        :total="total"
                        layout="sizes,prev, pager, next"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="pageSize"
                        @size-change="handleSizeChange"
                        @current-change="onPageChange"
                        @prev-click="onPageChange"
                        @next-click="onPageChange">
                    </el-pagination>
                </div>
            </el-card>
        </main>
        <el-dialog title="" :visible.sync="reviewVisible" :close-on-click-modal="false" width="1000px">
            <div style="display: flex;justify-content: space-between;">
                <div style=" width: 48%;">
                    <el-form ref="reviewForm" :model="reviewForm" :rules="rules" label-width="90px">
                        <el-form-item label="发票" prop="invoiceId" class="item">
                            <el-select v-model="reviewForm.invoiceId"  placeholder="发票"
                                       clearable    @change="selectChanged" style="width: 350px" >
                                <el-option
                                        v-for="item in invoiceList"
                                        :key="item.id"
                                        :label="item.companyName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <div >
                            <el-form-item label="公司:" prop="companyName"  class="item1">
                                <el-input v-model="reviewForm.companyName" :disabled="true"  style="width: 350px" clearable></el-input>
                            </el-form-item>

                        <el-form-item label="公司税号:" prop="companyTaxNo"  class="item1">
                          <el-input v-model="reviewForm.companyTaxNo" :disabled="true"  style="width: 350px" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="开户银行:" prop="bankName"  class="item1">
                            <el-input v-model="reviewForm.bankName" :disabled="true"  style="width: 350px" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="银行账号:" prop="bankAccount"  class="item1">

                            <el-input v-model="reviewForm.bankAccount" :disabled="true"  style="width: 350px" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="注册电话:" prop="registeredTel"  class="item1">

                            <el-input v-model="reviewForm.registeredTel" :disabled="true"  style="width: 350px" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="注册地址:" prop="registeredAddress" class="item1">

                            <el-input v-model="reviewForm.registeredAddress" :disabled="true"  style="width: 350px" clearable></el-input>
                        </el-form-item>
                        </div>

                    </el-form>
                </div>
                <div style=" width: 48%;">
                    <el-form ref="addressForm" :model="addressForm" :rules="rules" label-width="90px">
                        <el-form-item label="邮寄地址:">
                            <el-select v-model="addressId"  clearable placeholder="请选择"
                                     @clear="clearIt" @change="addressChanged"   style="width: 350px" >
                                <el-option
                                        v-for="(item,index) in addressList"
                                        :key="index"
                                        :label="item.address"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="行政区划:" prop="region"  class="item">
                            <v-region-selects v-model="addressForm.region"  @change="regionChange" :town="false" />
                        </el-form-item>
                        <el-form-item label="详细地址" prop="address" class="item">
                            <el-input v-model="addressForm.address" placeholder="请输入详细地址" style="width: 350px" clearable></el-input>
                        </el-form-item>

                        <el-form-item label="收件人" prop="consignee" class="item">
                            <el-input v-model="addressForm.consignee" placeholder="请输入收件人" style="width: 350px" clearable></el-input>
                        </el-form-item>
                        <el-form-item label="联系电话" prop="mobile" class="item">
                            <el-input v-model="addressForm.mobile" placeholder="请输入联系电话" style="width: 350px" clearable></el-input>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div style="margin: 10px">订单金额合计：￥{{money}}元</div>
            <el-divider></el-divider>
            <el-table
                    :data="selectData"
                    v-loading="loading"
                    style="width: 100%">
                <el-table-column
                    fixed
                    prop="sku"
                    label="SKU" width="180">
                </el-table-column>
                <el-table-column
                    prop="productName"
                    label="商品名称" width="300">
                </el-table-column>
                <el-table-column
                    prop="model"
                    label="商品型号" width="200">
                </el-table-column>
                <el-table-column
                    prop="num"
                    label="商品数量" width="100">
                </el-table-column>
                <el-table-column
                        prop="unit"
                        label="商品单位" width="100">
                </el-table-column>
                <el-table-column
                        prop="untaxedPrice"
                        label="未税单价(元)"
                        width="150"
                        align="center">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="已税总价(元)"
                    width="150"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="totalUntaxedPrice"
                    label="未税总价(元)"
                    width="150"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="totalPrice"
                    label="含价总价(元)"
                    width="150"
                    align="center">
                </el-table-column>
                <el-table-column
                    prop="email"
                    label="用户邮箱" width="180">
                </el-table-column>
                <el-table-column
                    prop="consignee"
                    label="收货人" width="100">
                </el-table-column>
                <el-table-column
                    prop="mobile"
                    label="收货人手机" width="120">
                </el-table-column>
                <el-table-column
                    prop="address"
                    label="收货地址" width="200">
                </el-table-column>
                <el-table-column
                    prop="createTime"
                    label="创建时间" width="200" align="center">
                </el-table-column>
                <el-table-column
                    fixed="right"
                    prop="status"
                    label="状态"
                    width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.status == 0">待下单</el-tag>
                        <el-tag v-if="scope.row.status == 2">已下单</el-tag>
                        <el-tag v-if="scope.row.status == 3">已发货</el-tag>
                        <el-tag v-if="scope.row.status == 4">已收货</el-tag>
                        <el-tag v-if="scope.row.status == 5">已取消</el-tag>
                        <el-tag v-if="scope.row.status == 6">已驳回</el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reviewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addVoice()">确定开票</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import {convertRes2Blob, downloadByPost} from "../../utils/download";

export default {

    data() {
        return {
            companys:[],
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            money: 0,
            invoiceList:[],
            addressList:[],
            reviewVisible:false,
            searchForm: {
                timeDate: "",
                status: "",
            },
            loading: false,
            total: 0,
            pageSize: 10,
            pageSizes: [10, 50, 100],
            currentPage: 1,
            tableData: [],

            addOrderForm: {
                id: "",
                orderBatch: "",
            },
            exportOrderVisible: false,
            exportOrderForm: {
                orderBatch: "",
            },

            orderForm: {
                orderBatch: "",
            },
            reviewForm: {
                id:"",
                companyId:"",
                invoiceId:"",
                companyName:"",//
                bankName:"",//
                bankAccount:"",//
                companyTaxNo:"",//
                registeredTel:"",//
                registeredAddress:"",//

            },
            addressId:"",
            addressForm: {
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town:""
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""//

            },
            selectData:[],//选中的数据
            rules: {
                address: [
                    { required: true, message: '请输入详细地址', trigger: 'blur' }
                ],
                consignee: [
                    { required: true, message: '请输入收件人', trigger: 'blur' }
                ],
                mobile: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' }
                ],

            },
        }
    },
    methods: {
        onSearch() {
            this.currentPage = 1;
            this.fetchData();
        },
        fetchData() {
            this.loading = true;
            this.selectData = [];
            let _this = this;
            let cond = {...this.searchForm};
            if(!this.searchForm.companyIds) {
                cond['companyIds'] = [];
            }
            if(!this.searchForm.status) {
                cond['status'] = undefined;
            }else if(this.searchForm.status == 10) {
                cond["isInvoice"] = false;
                cond["status"] = undefined;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                cond["startTime"] = this.searchForm.timeDate[0];
                cond["endTime"] = this.searchForm.timeDate[1];
            }
            this.$axios.post("/admin/invoice/productList",{
                cond,
                page: this.currentPage - 1,size:this.pageSize
            }).then(function(response) {
                let resp = response.data;
                if( resp.header.status == 0) {
                    _this.loading = false;
                    _this.tableData = resp.data.content;
                    _this.total = resp.data.totalElements;
                }
            }).catch(function() {
            });
        },
        exportData() {
            this.loading = true;
            this.selectData = [];
            let data = {...this.searchForm};
            if(!this.searchForm.companyIds) {
                data['companyIds'] = [];
            }
            if(!this.searchForm.status) {
                data['status'] = undefined;
            }else if(this.searchForm.status == 10) {
                data["isInvoice"] = false;
                data["status"] = undefined;
            }
            if(this.searchForm.timeDate != "" &&this.searchForm.timeDate!=null) {
                data["startTime"] = this.searchForm.timeDate[0];
                data["endTime"] = this.searchForm.timeDate[1];
            }
            downloadByPost({
                axios: this.$axios,
                url: "/admin/invoice/productList.xlsx",
                data,
                success: response => {
                    convertRes2Blob(response);
                },
                complete: () => {
                    this.loading = false;
                }
            });
        },
        judgeSelect(row){
            if(row.isInvoice == null){
                return true;
            }
            return row.isInvoice == false // 返回true该行可选，返回false则不可选
        },
        selectChanged(invoiceId) {
            if(invoiceId != null && invoiceId != ""){

                let one = null;
                for(let i=0;i<this.invoiceList.length;i++){
                    let item = this.invoiceList[i];
                    if(item.id == invoiceId){
                        one = item;
                    }
                }
                if(one != null) {
                    this.reviewForm = one;
                    this.reviewForm.invoiceId = invoiceId;
                }

            }else{
                this.reviewForm = {};
                this.reviewForm.invoiceId = "";
            }

        },
        addressChanged(addressId) {
            this.addressId = '';
            this.addressId = addressId;
            //this.$set(this.addressForm, 'id', '')
           // this.$set(this.addressForm,'id',addressId);
           // this.$forceUpdate();
            if(addressId != null && addressId != ""){

                let one = null;
                for(let i=0;i<this.addressList.length;i++){
                    let item = this.addressList[i];
                    if(item.id == addressId){
                        one = item;
                    }
                }
                if(one != null){
                    this.addressForm = one;
                    let region = {};
                    if(one.provinceId != null){
                        region.province = one.provinceId;
                    }
                    if(one.cityId != null){
                        region.city = one.cityId;
                    }
                    if(one.countyId != null){
                        region.area = one.countyId;
                    }
                    region.town = '';
                    this.addressForm.region = region;
                }

            }else{

                // this.addressForm.id = addressId;
                // this.addressForm.region = {province:"",city:"",area:"",town:""};
                // this.$set(this.addressForm, this.addressForm.id, '');
                this.addressForm = {
                    region: {
                        province: '',
                            city: '',
                            area: '',
                            town:""
                    },
                    id:"",
                        mobile:"",
                        address:"",//
                        consignee:"",//
                        county:"",//
                        city:"",//
                        province:"",//
                        provinceId:"",//
                        cityId:"",//
                        countyId:""//

                }


            }
            //this.$set(this.addressForm,'id',addressId);

        },
        loadInvoice(){
            let _this = this
            this.$axios.post("/admin/invoice/customer/list"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.invoiceList = resp.data;
                }

            });

        } ,
        loadAddress(){
            let _this = this
            this.$axios.get("/admin/address/getAddress"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.addressList = resp.data;
                }

            });

        } ,
        regionChange (data) {

            //{"province":{"key":"130000","value":"河北省"},"city":{"key":"130100","value":"石家庄市"},"area":{"key":"130105","value":"新华区"}}

            if(data.province != null){
                this.addressForm.province = data.province.value;
                this.addressForm.provinceId = data.province.key;
            }

            if(data.city != null){
                this.addressForm.city = data.city.value;
                this.addressForm.cityId = data.city.key;
            }
            if(data.area != null){
                this.addressForm.county = data.area.value;
                this.addressForm.countyId = data.area.key;
            }

        },
        saveAddress() {
            const that = this;
            this.$refs.addressForm.validate(valid => {
                if(valid) {
                    this.$axios.post("/admin/address/save", this.addressForm)
                        .then(function (response) {
                            let resp = response.data;
                            if (resp.header.status == 0) {
                                // that.$notify({
                                //     title: '成功',
                                //     message: '数据保存成功',
                                //     type: 'success'
                                // });
                                that.addressId = resp.data.id;
                                that.saveSettlement();
                            } else {
                                that.$notify.error({
                                    title: '错误',
                                    message: resp.header.msg
                                });
                            }
                        });
                }
            });
        },

        showReviewDialog() {//打开发票对话框
        //     this.reviewForm =
        //         {
        //             id: "",
        //             companyId: "",
        //             invoiceId: "",
        //             companyName: "",//
        //             bankName: "",//
        //             bankAccount: "",//
        //             companyTaxNo: "",//
        //             registeredTel: "",//
        //             registeredAddress: ""
        //         };
        //     this.clearIt();
        //     if(this.selectData.length == 0){
        //         this.$message({
        //             type: 'info',
        //             message: '请选择要开发票的订单',
        //             duration: 2000
        //         });
        //         return;
        //     }
        //     this.loadInvoice();
        //    // if(this.addressList.length==0){
        //         this.loadAddress();
        //    // }
        //     //this.loadAddress();
        //     this.money = 0;
        //     this.selectData.map(it => {this.money = this.money+it.totalPrice});
        //     if(this.money){
        //         this.money = this.money.toFixed(2);
        //     }
        //     this.reviewVisible = true;

        },
        clearIt(){
            this.addressId = "";
            this.addressForm={
                region: {
                    province: '',
                    city: '',
                    area: '',
                    town: ''
                },
                id:"",
                mobile:"",
                address:"",//
                consignee:"",//
                county:"",//
                city:"",//
                province:"",//
                provinceId:"",//
                cityId:"",//
                countyId:""

            }

        },
        handleSizeChange(pageSize){
            this.pageSize = pageSize;
            this.fetchData();
        },

        onPageChange(currentPage) {
            this.currentPage = currentPage;
            this.fetchData();
        },
        saveSettlement(){
            const that = this;
            let data = {};
            data.invoiceId = this.reviewForm.invoiceId;
            data.addressId = this.addressId;

            let ids =  this.selectData.map(it => it.id);
            data.orderIds = ids;
            data.companyId = this.reviewForm.companyId;
            data.companyName = this.reviewForm.companyName;
            data.totalPrice = this.money;
            this.$axios.post("/admin/invoice/saveSettlement", data)
                .then(function (response) {
                    let resp = response.data;
                    if (resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '数据保存成功',
                            type: 'success'
                        });
                        that.fetchData();
                        that.reviewVisible = false;
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                });
        },
        addVoice(){//确定开发票

            if(this.reviewForm.invoiceId=="" ||this.reviewForm.invoiceId == null ){
                this.$message({
                    type: 'info',
                    message: '请选择发票',
                    duration: 1000
                });
                return;
            }
            if(this.addressId=="" ||this.addressId == null ){
                this.saveAddress();

            }else{
                this.saveSettlement();
            }
        },

        handleToReviewDetail(row) {
            let showBtn = (row.status == 0&&row.review);

            this.$router.push({name: "customerReviewDetail", params: {from: "rfq", orderId: row.id,
                    step:row.reviewStep, workflowId:row.workflowId, name:row.consignee,totalPrice:row.totalPrice,showBtn:showBtn}})



        },
        handleToDeliver(row) {

            this.$router.push({name: "deliver", params: {from: "order", orderId: row.id
                   }});
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        loadCompanys(){
            let _this = this
            this.$axios.post("/admin/company/companys"
            ).then(function (response) {
                let resp = response.data;
                if (resp.header.status == 0) {
                    _this.companys = resp.data;
                }

            });

        },

    },
    created() {
        this.fetchData();
        this.loadAddress();
        this.loadCompanys();

    },
}
</script>
<style>

    .item {

        margin-bottom: 0px;

    }
    .item1 {
        margin-top: -10px;
        margin-bottom: 0px;

    }
</style>